import { Tabs } from "antd";
import { Content } from "antd/lib/layout/layout";
import React, { useEffect, useState } from "react";
import DashboardBreadcrumb from "../../components/layout/DashboardBreadcrumb";
import PageLoader from "../../components/sub/PageLoader";
import {
  openNotificationError,
  openNotificationSuccess,
} from "../../helpers/NotificationHelpers";
import { useSelector } from "react-redux";
import { LIMIT_PER_PAGE } from "../../helpers/constants";
import PlanApprovalsTable from "../../components/tables/PlanApprovalsTable";
import { GetPlanApprovalsApi } from "../../api/approvals/GetPlanApprovalsApi";
import PlanApprovalActionApi from "../../api/approvals/PlanApprovalActionApi";

const { TabPane } = Tabs;

function PlanApprovals() {
  const [data, setData] = useState("");
  const [page, setPage] = useState(1);
  const [loading, setLoading] = useState(false);
  const [tableLoading, setTableLoading] = useState(false);
  const [selectedTab, setSelectedTab] = useState("all");
  const proHeight = document.body.clientHeight;
  const positionState = useSelector((state) => state.positionState.value);

  useEffect(() => {
    setLoading(true);
    positionState?.id && getPlanApprovals(page, "");
  }, [positionState]);

  // get all data
  async function getPlanApprovals(num, status) {
    setTableLoading(true);
    const apiResponse = await GetPlanApprovalsApi(
      num,
      status,
      positionState.id,
      LIMIT_PER_PAGE
    );
    if (apiResponse.success) {
      setData(apiResponse?.data?.planApprovals);
    }
    setLoading(false);
    setTableLoading(false);
  }

  // approve and reject
  async function approveApproval(id, action, from) {
    setTableLoading(true);
    const apiResponse = await PlanApprovalActionApi(
      id,
      action,
      positionState?.id
    );
    if (apiResponse.error) {
      openNotificationError("bottomRight", apiResponse.message);
    } else if (apiResponse.success) {
      openNotificationSuccess("bottomRight", apiResponse.message);
      if (from === "pending") {
        if (data?.length === 1) {
          changeTablePage(page === 1 ? page : page - 1);
        } else {
          changeTablePage(page);
        }
      } else if (from === "all") {
        if (data?.length === 1) {
          changeTablePage(page === 1 ? page : page - 1);
        } else {
          changeTablePage(page);
        }
      }
    } else {
      openNotificationError(
        "bottomRight",
        "Couldn't approve. Try again later."
      );
    }
    setTableLoading(false);
  }

  async function rejectApproval(id, action, from) {
    setTableLoading(true);
    const apiResponse = await PlanApprovalActionApi(
      id,
      action,
      positionState?.id
    );
    if (apiResponse.error) {
      openNotificationError("bottomRight", apiResponse.message);
    } else if (apiResponse.success) {
      openNotificationSuccess("bottomRight", apiResponse.message);
      if (from === "pending") {
        if (data?.length === 1) {
          changeTablePage(page === 1 ? page : page - 1);
        } else {
          changeTablePage(page);
        }
      } else if (from === "all") {
        if (data?.length === 1) {
          changeTablePage(page === 1 ? page : page - 1);
        } else {
          changeTablePage(page);
        }
      }
    } else {
      openNotificationError("bottomRight", "Couldn't reject. Try again later.");
    }
    setTableLoading(false);
  }

  function changeTablePage(num) {
    getData(num);
  }

  function changeTab(key) {
    setLoading(true);
    if (key === "1") {
      setSelectedTab("all");
      getPlanApprovals(page, "");
    } else if (key === "2") {
      setSelectedTab("pending");
      getPlanApprovals(page, "Pending");
    } else if (key === "3") {
      setSelectedTab("approved");
      getPlanApprovals(page, "Approved");
    } else if (key === "4") {
      setSelectedTab("rejected");
      getPlanApprovals(page, "Rejected");
    }
  }

  function getData(num) {
    if (selectedTab === "all") {
      getPlanApprovals(num, "");
    } else if (selectedTab === "pending") {
      getPlanApprovals(num, "Pending");
    } else if (selectedTab === "approved") {
      getPlanApprovals(num, "Approved");
    } else if (selectedTab === "rejected") {
      getPlanApprovals(num, "Rejected");
    }
  }

  const left = <div className="pri-font text-lg">Plan Approvals</div>;

  return (
    <>
      <Content style={{ backgroundColor: "#fff" }}>
        <DashboardBreadcrumb left={left} />
        <div
          style={{
            height: proHeight - 122,
            overflow: "auto",
          }}
          className="custom-scroll"
        >
          <Tabs onChange={changeTab} defaultActiveKey="1" centered>
            <TabPane tab={<div className="w-32 text-center ">All</div>} key="1">
              <div className="px-6 pb-6">
                {!loading ? (
                  <PlanApprovalsTable
                    data={data}
                    approveApproval={(id, action, from) =>
                      approveApproval(id, action, from)
                    }
                    rejectApproval={(id, action, from) =>
                      rejectApproval(id, action, from)
                    }
                    changePage={(num) => changeTablePage(num)}
                    current={page}
                    setPage={(num) => setPage(num)}
                    tableLoading={tableLoading}
                  />
                ) : (
                  <PageLoader />
                )}
              </div>
            </TabPane>
            <TabPane
              tab={<div className="w-32  text-center">Pending</div>}
              key="2"
            >
              <div className="px-6 pb-6">
                {!loading ? (
                  <PlanApprovalsTable
                    data={data}
                    approveApproval={(id, action, from) =>
                      approveApproval(id, action, from)
                    }
                    rejectApproval={(id, action, from) =>
                      rejectApproval(id, action, from)
                    }
                    changePage={(num) => changeTablePage(num)}
                    current={page}
                    setPage={(num) => setPage(num)}
                    tableLoading={tableLoading}
                  />
                ) : (
                  <PageLoader />
                )}
              </div>
            </TabPane>
            <TabPane
              tab={<div className="w-32 text-center ">Approved</div>}
              key="3"
            >
              <div className="px-6 pb-6">
                {!loading ? (
                  <PlanApprovalsTable
                    data={data}
                    changePage={(num) => changeTablePage(num)}
                    current={page}
                    setPage={(num) => setPage(num)}
                    tableLoading={tableLoading}
                  />
                ) : (
                  <PageLoader />
                )}
              </div>
            </TabPane>
            <TabPane
              tab={<div className="w-32 text-center">Rejected</div>}
              key="4"
            >
              <div className="px-6 pb-6">
                {!loading ? (
                  <PlanApprovalsTable
                    data={data}
                    changePage={(num) => changeTablePage(num)}
                    current={page}
                    setPage={(num) => setPage(num)}
                    tableLoading={tableLoading}
                  />
                ) : (
                  <PageLoader />
                )}
              </div>
            </TabPane>
          </Tabs>
        </div>
      </Content>
    </>
  );
}

export default PlanApprovals;
